import { Card, Col, Form, message, Row } from "antd";

import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { formatNumber } from "../../../Utils/index";

import axios from "services/axiosB2C";
import { RequestToken } from "../../../../services/b2c";

const FormItem = Form.Item;

class CarBookingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carBooking: {},
    };
  }

  componentDidMount() {
    this.getCarBookingDetail(this.props.match.params.id);
  }

  async getCarBookingDetail(id) {
    try {
      let token = await RequestToken();
      axios
        .get(`/carbookings/${id}`, {
          headers: {
            Authorization: token,
          },
        })
        .then(result => {
          this.setState({ carBooking: result.data.carBooking });
        })
        .catch(err => {
          message.error("Gagal request data car booking");
        });
    } catch (e) {
      message.error("Gagal request data car booking");
    }
  }

  render() {
    const { carBooking } = this.state;
    const { customercar } = carBooking;

    return carBooking.id ? (
      <Card title="Customer Car">
        <div id="carBookingService">
          <Row>
            <Col xs={24} md={12}>
              <Card title="NAMA CUSTOMER">
                <span className="ant-form-text form-text-mod">
                  {carBooking.name}
                </span>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="HARI/TGL DIBUAT">
                <span className="ant-form-text form-text-mod">
                  {moment(carBooking.created_at).format(
                    "dddd, D MMMM YYYY HH:mm"
                  )}
                </span>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={12}>
              <Card title="EMAIL CUSTOMER">
                <span className="ant-form-text form-text-mod">
                  {carBooking.email}
                </span>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="HARI/TGL BOOKING SERVICE">
                <span className="ant-form-text form-text-mod">
                  {moment(carBooking.service_date).format(
                    "dddd, D MMMM YYYY HH:mm"
                  )}
                </span>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12}>
              <Card title="NO HP CUSTOMER">
                <span className="ant-form-text form-text-mod">
                  {carBooking.phone}
                </span>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card title="CABANG">
                <span className="ant-form-text form-text-mod">
                  {carBooking.branch}
                </span>
              </Card>
            </Col>
          </Row>

          <Row>
            <Card title="DATA SERVICE BOOKING">
              <Col xs={24} md={12}>
                <FormItem label="Nama Mobil">
                  <span
                    className="ant-form-text form-text-mod"
                    style={{ lineHeight: "30px" }}>
                    {carBooking.car_name}
                  </span>
                </FormItem>
                <FormItem label="Warna">
                  <span className="ant-form-text form-text-mod">
                    {customercar ? customercar.color : null}
                  </span>
                </FormItem>
                <FormItem label="Provinsi">
                  <span className="ant-form-text form-text-mod">
                    {carBooking.province}
                  </span>
                </FormItem>
                <FormItem label="Kota">
                  <span className="ant-form-text form-text-mod">
                    {carBooking.city}
                  </span>
                </FormItem>
                <FormItem label="Email Member">
                  <span className="ant-form-text form-text-mod">
                    {customercar
                      ? customercar.user
                        ? customercar.user.email
                        : null
                      : null}
                  </span>
                </FormItem>
                <FormItem label="Nama Member">
                  <span className="ant-form-text form-text-mod">
                    {customercar
                      ? customercar.user
                        ? customercar.user.userprofile
                          ? customercar.user.userprofile.name
                          : null
                        : null
                      : null}
                  </span>
                </FormItem>
                <FormItem label="No Hp Member">
                  <span className="ant-form-text form-text-mod">
                    {customercar
                      ? customercar.user
                        ? customercar.user.userprofile
                          ? customercar.user.userprofile.phone
                          : null
                        : null
                      : null}
                  </span>
                </FormItem>
              </Col>
              <Col xs={24} md={12}>
                <FormItem label="Tipe Service">
                  <span className="ant-form-text form-text-mod">
                    {carBooking.service_type}
                  </span>
                </FormItem>
                <FormItem label="Nomor Polisi">
                  <span className="ant-form-text form-text-mod">
                    {customercar ? customercar.license_plate : null}
                  </span>
                </FormItem>
                <FormItem label="Nomor Rangka">
                  <span className="ant-form-text form-text-mod">
                    {customercar ? customercar.engine_number : null}
                  </span>
                </FormItem>
                <FormItem label="Tahun STNK">
                  <span className="ant-form-text form-text-mod">
                    {moment(customercar ? customercar.stnk_term : null).format(
                      "YYYY-MM-DD"
                    )}
                  </span>
                </FormItem>
                <FormItem label="Jarak Tempuh">
                  <span className="ant-form-text form-text-mod">
                    {formatNumber(carBooking.mileage)}
                  </span>
                </FormItem>
                <FormItem label="Catatan Customer">
                  <span className="ant-form-text form-text-mod">
                    {carBooking.service_notes}
                  </span>
                </FormItem>
              </Col>
            </Card>
          </Row>
        </div>
      </Card>
    ) : null;
  }
}

export default CarBookingDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/CarBooking/CarBookingDetail.js